var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.207782 6.36063L5.99828 0.570236C6.13209 0.436431 6.31049 0.362976 6.50486 0.362976C6.69531 0.362976 6.87383 0.436431 7.00742 0.570236L12.7925 6.35513C12.9263 6.48905 13 6.66756 13 6.85801C13 7.04847 12.9264 7.22709 12.7925 7.36089L12.3665 7.78693C12.2327 7.92074 12.0541 7.99462 11.8636 7.99462C11.6732 7.99462 11.4946 7.92074 11.3607 7.78693L6.50285 2.92905L1.63958 7.79253C1.50577 7.92623 1.32726 8 1.1367 8C0.946244 8 0.767838 7.92623 0.633927 7.79253L0.207782 7.36628C-0.0693407 7.08905 -0.0693407 6.63786 0.207782 6.36063Z",
    fill: "#304059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.e46637d47e4995e8adc8e5bbf10344d4.svg";
export { ForwardRef as ReactComponent };